import React, { useEffect, useState } from 'react';
import IconForCall from "./IconForCall";
import { history1 } from "../translate";

function DisplayTrack({ currentTrack, audioRef, setDuration, interacted, progressBarRef, isDrag = false }) {
    const [loading, setLoading] = useState(false);
    const [audioSrc, setAudioSrc] = useState('');
    const [speed, setSpeed] = useState(1); // default speed = normal

    const onLoadedMetadata = () => {
        if (!audioRef.current) return;
        audioRef.current.playbackRate = speed;
        const seconds = audioRef.current.duration;
        setDuration(seconds);
        progressBarRef.current.max = seconds;
    };

    const fetchAudio = async () => {
        try {
            setLoading(true)
            const response = await fetch(currentTrack?.src);
            const blob = await response.blob();
            const fileURL = URL.createObjectURL(blob);
            setAudioSrc(fileURL);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching audio file:', error);
        }
    };

    useEffect(() => {
        (async () => await fetchAudio())()
    }, [currentTrack?.src]);

    useEffect(() => {
        if (!audioRef.current || !audioSrc) return;
        audioRef.current.playbackRate = speed;
    }, [audioSrc, speed]);

    useEffect(() => {
        const playAudio = async () => {
            if (audioRef.current && interacted) {
                try {
                    audioRef.current.playbackRate = speed; // apply speed
                    await audioRef.current.play();
                } catch (error) {
                    console.error("Playback error:", error);
                }
            }
        };

        if (audioSrc) {
            playAudio();
        }
    }, [audioSrc, interacted, speed]); // speed is a dependency

    const [speeds] = useState([1, 1.25, 1.5, 1.75, 2]);

    const toggleSpeed = () => {
        const currentIndex = speeds.indexOf(speed);
        const nextIndex = (currentIndex + 1) % speeds.length;
        const newSpeed = speeds[nextIndex];

        setSpeed(newSpeed);

        if (audioRef.current) {
            audioRef.current.playbackRate = newSpeed;
        }
    };
    return (
        <div className="d-flex align-items-center">
            <audio src={audioSrc} ref={audioRef} onLoadedMetadata={onLoadedMetadata} />
            <div className="audio-info">
                {isDrag?loading ? "Loading..." : (
                    <div className="text">
                        <p className="title">
                            {currentTrack?.type === 'Outgoing'
                                ? <IconForCall color={history1.callType[2].color} path={history1.callType[2].path} />
                                : <IconForCall color={history1.callType[0].color} path={history1.callType[0].path} />
                            }
                        </p>
                        <p>{currentTrack?.fname || ""}</p>

                    </div>
                ):null}
                <button
                    style={{ background: "white", border: "none", marginLeft: 20 }}
                    onClick={toggleSpeed}
                >
                    ▶ x{speed}
                </button>

            </div>
        </div>
    );
}

export default DisplayTrack;
